const formatPhoneNumber = (phoneNumber) => {
  const numericOutput = phoneNumber.replace(/[^0-9]/g, '');
  const { length } = numericOutput;
  if (length < 10 || length >= 12) {
    return '';
  }
  return `+1${numericOutput.substring(length - 10)}`;
};

export default formatPhoneNumber;
